module.exports = __webpack_public_path__ + "static/media/5.Multi-Functional-Hoist.9ae4ff6c.webp";